import _extends from "@babel/runtime/helpers/extends";
import { Icon } from '@atlaskit/icon/base';
import { N500 } from '@atlaskit/theme/colors';
import React from 'react';
const CloudFortifiedReliabilityIcon = props => {
  const CloudFortifiedReliabilityGlyph = () => /*#__PURE__*/React.createElement("svg", {
    className: props.className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9226 13.25H17.625C17.349 13.25 17.1057 13.069 17.0264 12.8046L15.823 8.79346L13.8584 17.1432C13.7938 17.4178 13.5531 17.6151 13.2711 17.6246C12.989 17.6342 12.7356 17.4535 12.6526 17.1838L10.6114 10.5498L9.43402 12.9045C9.33715 13.0983 9.14686 13.228 8.93113 13.2475C8.71539 13.2669 8.50497 13.1733 8.375 13L7 11.1667L5.625 13C5.50697 13.1574 5.32172 13.25 5.125 13.25H2.07737C2.69249 18.1829 6.90048 22 12 22C17.0995 22 21.3075 18.1829 21.9226 13.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12H4.8125L6.5 9.75C6.61803 9.59262 6.80328 9.5 7 9.5C7.19672 9.5 7.38197 9.59262 7.5 9.75L8.76824 11.441L10.191 8.59549C10.3052 8.36702 10.547 8.23106 10.8015 8.25213C11.0561 8.2732 11.2722 8.44706 11.3474 8.6912L13.1695 14.6132L15.1416 6.23185C15.2064 5.95637 15.4483 5.75883 15.7311 5.75028C16.014 5.74174 16.2673 5.92434 16.3486 6.19541L18.09 12H22Z",
    fill: "currentColor"
  }));
  return /*#__PURE__*/React.createElement(Icon, _extends({
    glyph: CloudFortifiedReliabilityGlyph,
    primaryColor: "var(--ds-icon, ".concat(N500, ")")
  }, props));
};
export default CloudFortifiedReliabilityIcon;